import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import styles from './Ibtikar.module.css';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import { Util } from '../../../config/Util';
import toast from 'react-hot-toast';

const Implementation = () => {
  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [updateRow, setUpdateRow] = useState(null);
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [implementationImage, setImplementationImage] = useState(null);
  const [implementationComment, setImplementationComment] = useState('');
  const [users, setUsers] = useState([]);

  const getStatusClass = (status) => {
    if (!status) return '';
    const s = String(status).toLowerCase();
    if (s.includes('completed')) return styles.statusApproved; // green
    if (s.includes('rejected')) return styles.statusRejected;  // red
    if (s.includes('open')) return styles.statusOpen;
    if (s.includes('implementation')) return styles.statusImplementation;
    if (s.includes('review')) return styles.statusReview;
    return '';
  };

  const getSubmittedBy = (empId) => {
    if (!empId) return 'NA';
    const user = users.find(u => u.username === empId || u.name === empId);
    if (!user) return empId;
    const username = user.username || '';
    const name = user.name || '';
    if (username && name) return `${username} - ${name}`;
    return username || name || empId;
  };

  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true, center: true, grow: 0.5, maxWidth: '60px' },
    {
      name: 'TITLE',
      selector: row => row.ideaProblem,
      sortable: true,
      center: true,
      grow: 3,
      cell: row => (
        <span className={styles.tableEllipsis} title={row.ideaProblem}>
          {row.ideaProblem}
        </span>
      ),
      minWidth: '120px',
      maxWidth: '240px',
    },
    { name: 'DATE', selector: row => row.ideaDate, center: true, maxWidth: '90px' },
    {
      name: 'SUBMITTED BY',
      selector: row => getSubmittedBy(row.empId),
      center: true,
      cell: row => {
        const label = getSubmittedBy(row.empId);
        return <span className={styles.tableEllipsis} title={label}>{label}</span>;
      },
    },
    { name: 'STATUS', selector: row => (row && row.status ? String(row.status).toUpperCase() : ''), center: true, maxWidth: '130px' },
    {
      name: 'ACTIONS',
      cell: row => (
        <button
          className='btn btn-info'
          onClick={() => { setModalData(row); setModalOpen(true); }}
        >
          VIEW
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'ACTIONS',
      cell: row => {
        const status = row && row.status ? String(row.status).toLowerCase() : '';
        const canUpdate = status.includes('implementation');
        return (
          <button
            className='btn btn-success'
            disabled={!canUpdate}
            onClick={() => { if (canUpdate) { setUpdateRow(row); setUpdateOpen(true); setConfirmChecked(false); } }}
          >
            UPDATE
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    const initializeFunctions = async () => {
      await fetchUsers();
      await listIdeas();
    };

    initializeFunctions();
  }, []);

  const fetchUsers = async () => {
    try {
      const resp = await axios.get(API.listUser);
      if (resp && resp.status === 200 && resp.data) {
        const filteredUsers = resp.data.users.filter(user => user.role !== 'SUPER_ADMIN');
        setUsers(filteredUsers);
      }
    } catch (er) {
      console.log('Error fetching users:', er);
    }
  };


  const listIdeas = async () => {
    //API call logic goes here
    const auth = Util.getFromSession("auth");
    const userId = auth && auth.id ? auth.id : undefined;

    try {
      setLoader(true);
      const resp = await axios.get(API.myIdeas, { params: { userId } });
      //Process and set data
      if (resp && resp.data && resp.data.status === 'S' && Array.isArray(resp.data.ideas)) {

        //filter assigned ideas only 
        const assignedIdeas = resp.data.ideas.filter((idea) => Number(idea.assignee) === Number(userId));

        setData(assignedIdeas);
        setFullData(assignedIdeas);
      }
    } catch (err) {
      console.log("error while fetching ideas.");
    } finally {
      setLoader(false);
    }
  }



  const submitIdeaForReview = async (row) => {
    if (!row || !row.id) {
      return;
    }
    try {
      // Close modal and reset state
      setUpdateOpen(false);
      setUpdateRow(null);
      setConfirmChecked(false);
      setLoader(true);

      // Create FormData to handle image upload
      const jsonPayload = {
        id: row.id,
        status: 'review',
        comment: implementationComment || ''
      };
      console.log("Submitting for review with payload:", jsonPayload);
      const formData = new FormData();

      // Append JSON as a Blob
      formData.append(
        'data',
        new Blob([JSON.stringify(jsonPayload)], { type: 'application/json' })
      );

      // Append image if available
      if (implementationImage) {
        formData.append('implementationImage', implementationImage);
      }

      // API call to move idea to review status with image
      const resp = await axios.post(API.submitForReview, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // validate resp (expect 200/201 and data.status === 'S')
      if (resp && (resp.status === 200 || resp.status === 201) && resp.data && resp.data.status === 'S') {
        // Refresh list on success
        toast.success("Successfully Submitted For Review");
        setImplementationImage(null);
        setImplementationComment('');
        await listIdeas();
      } else {
        toast.error("Failed to submit. Try again later.");
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to submit. Try again later.");
    } finally {
      setLoader(false);
    }
  }

  const filterData = (e) => {
    const key = e.target.value || '';
    if (!key) return setData(fullData);
    const filtered = fullData.filter(item => item.name.toLowerCase().includes(key.toLowerCase()));
    setData(filtered);
  };

  return (
    <>
      <Loader loading={loader}></Loader>
      <div className={styles.container || ''} data-testid="ibtikar-implementation">
        <div className='bread-crumb overflow-auto'>
          <div>
            <span className='breadcrumb-title'>
              <input type='button' className='btn' value='Home - Implementation'></input>
            </span>
          </div>
        </div>

        <div className='data-table-holder'>
          <div className='table-search-box'>
            <input type='text' placeholder='Search Here..' className='form-control' onChange={filterData} />
          </div>

          <DataTable
            subHeaderAlign='center'
            columns={columns}
            data={data}
            pagination
            striped
          />
          {modalOpen && modalData && (
            <div className={styles.modalOverlay}>
              <div className={`${styles.modalCard} card p-0`}>
                <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                  <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                    <h5 className='m-0'>Submission Details</h5>
                    <span className={`${styles.statusBadge} ${getStatusClass(modalData.status)}`}>{modalData.status || 'Unknown'}</span>
                  </div>
                  <button className={`btn btn-danger `} onClick={() => { setModalOpen(false); setModalData(null); }}>X</button>
                </div>
                <div className={styles.modalBody}>
                  <div className={styles.modalSection}>
                    <div className={styles.modalSectionTitle}>Submission Info</div>
                    <div className='row'>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>ID:</strong> {modalData.id}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Title:</strong> {modalData.name || modalData.ideaProblem}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Submitted:</strong> {modalData.submitted || modalData.ideaDate || (modalData.meta && modalData.meta.idea_date)}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Submit Type:</strong> {modalData.submitType || (modalData.meta && modalData.meta.submitType)}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Employee ID:</strong> {modalData.empId || (modalData.meta && modalData.meta.empId)}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Category:</strong> {modalData.category || (modalData.meta && modalData.meta.category) || <span className={styles.modalTextMuted}>-</span>}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Sub-Category:</strong> {modalData.subCategory || (modalData.meta && modalData.meta.subCategory) || <span className={styles.modalTextMuted}>-</span>}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Email:</strong> {modalData.submitterEmail || (modalData.meta && modalData.meta.submitter && modalData.meta.submitter.email) || <span className={styles.modalTextMuted}>-</span>}</div>
                      </div>
                      <div className='col-sm-6'>
                        <div className={styles.modalField}><strong>Phone:</strong> {modalData.submitterPhone || (modalData.meta && modalData.meta.submitter && modalData.meta.submitter.phone) || <span className={styles.modalTextMuted}>-</span>}</div>
                      </div>
                      {(modalData.submitType === 'group' || (modalData.meta && modalData.meta.submitType === 'group')) && (modalData.members || (modalData.meta && modalData.meta.members)) && (
                        <div className='col-sm-12'>
                          <div className={styles.modalField}>
                            <strong>Group Members:</strong>
                            <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                              {(modalData.members || (modalData.meta && modalData.meta.members) || []).map((member, index) => (
                                <span
                                  key={index}
                                  style={{
                                    padding: '4px 10px',
                                    backgroundColor: '#e3f2fd',
                                    borderRadius: '12px',
                                    fontSize: '13px',
                                    color: '#1976d2'
                                  }}
                                >
                                  {member}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={styles.modalSection}>
                    <div className={styles.modalSectionTitle}>Idea Details</div>
                    <div className={styles.modalField}><strong>Idea / Problem:</strong><br />{modalData.ideaProblem || (modalData.meta && modalData.meta.ideaProblem) || <span className={styles.modalTextMuted}>-</span>}</div>
                    <div className={styles.modalField}><strong>Root Cause:</strong><br />{modalData.rootCause || (modalData.meta && modalData.meta.rootCause) || <span className={styles.modalTextMuted}>-</span>}</div>
                    <div className={styles.modalField}><strong>Solution Proposed:</strong><br />{modalData.solutionProposed || (modalData.meta && modalData.meta.solutionProposed) || <span className={styles.modalTextMuted}>-</span>}</div>
                    <div className={styles.modalField}><strong>Benefits:</strong><br />{modalData.benefits || (modalData.meta && modalData.meta.benefits) || <span className={styles.modalTextMuted}>-</span>}</div>
                    {modalData.rejectionComment && (
                      <div className={styles.modalField}><strong>Rejection comment:</strong><br />{modalData.rejectionComment}</div>
                    )}
                    {modalData.implementorComment && (
                      <div className={styles.modalField}><strong>Implementor Comment:</strong><br />{modalData.implementorComment}</div>
                    )}

                    <div className={styles.modalRow} style={{ marginTop: '0.5rem' }}>
                      <div style={{ flex: '1 1 300px' }}>
                        <div className={styles.modalField}><strong>Before Image:</strong></div>
                        {modalData.beforeImage ? (
                          typeof modalData.beforeImage === 'string' ? <img className={styles.modalImage} src={modalData.beforeImage.startsWith('http') ? modalData.beforeImage : Util.baseURlForDownload + modalData.beforeImage} alt='before' /> : <div className='text-muted'>{modalData.beforeImage.name || 'Uploaded file'}</div>
                        ) : <div className='text-muted'>No image</div>}
                      </div>
                      <div style={{ flex: '1 1 300px' }}>
                        <div className={styles.modalField}><strong>After Image:</strong></div>
                        {modalData.afterImage ? (
                          typeof modalData.afterImage === 'string' ? <img className={styles.modalImage} src={modalData.afterImage.startsWith('http') ? modalData.afterImage : Util.baseURlForDownload + modalData.afterImage} alt='after' /> : <div className='text-muted'>{modalData.afterImage.name || 'Uploaded file'}</div>
                        ) : <div className='text-muted'>No image</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {updateOpen && updateRow && (
            <div className={styles.modalOverlay}>
              <div className={`${styles.modalCard} card p-0`}>
                <div className={`d-flex justify-content-between align-items-center ${styles.modalHeader}`}>
                  <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                    <h5 className='m-0'>Mark as Implemented</h5>
                  </div>
                  <button className={`btn btn-danger `} onClick={() => { setUpdateOpen(false); setUpdateRow(null); setConfirmChecked(false); setImplementationImage(null); setImplementationComment(''); }}>X</button>
                </div>
                <div className={styles.modalBody}>
                  <div className={styles.modalSection}>
                    <div className={styles.modalField}>
                      <label className='form-label'><strong>Upload Implementation Image:</strong></label>
                      <input
                        type='file'
                        className='form-control'
                        accept='image/*'
                        onChange={(e) => setImplementationImage(e.target.files && e.target.files[0] ? e.target.files[0] : null)}
                      />
                      {/* {implementationImage && (
                      <div className='text-muted mt-2' style={{ fontSize: '0.875rem' }}>
                        Selected: {implementationImage.name}
                      </div>
                    )} */}
                    </div>
                    <div className={styles.modalField} style={{ marginTop: '1rem' }}>
                      <label className='form-label'><strong>Comment:</strong></label>
                      <textarea
                        className='form-control'
                        rows='3'
                        placeholder='Enter your implementation comments...'
                        value={implementationComment}
                        onChange={(e) => setImplementationComment(e.target.value)}
                      />
                    </div>
                    <div className={styles.modalField} style={{ marginTop: '1rem' }}>

                      <div className="form-check">
                        <input
                          id="confirmImplemented"
                          className="form-check-input"
                          type="checkbox"
                          checked={confirmChecked}
                          onChange={(e) => setConfirmChecked(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="confirmImplemented" style={{ marginLeft: '0.35rem' }}>
                          I have implemented the idea and submitting for the review of facilitator.
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.modalFooter}>
                  <button className={`btn ${styles.btnOutlineSecondary}`} onClick={() => { setUpdateOpen(false); setUpdateRow(null); setConfirmChecked(false); setImplementationImage(null); setImplementationComment(''); }}>Cancel</button>
                  <button className={`btn btn-warning`} disabled={!confirmChecked} onClick={() => submitIdeaForReview(updateRow)}>Confirm</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Implementation;
